module.exports = __webpack_public_path__ + "static/media/Mars2.efd23055.jpg";